<template>
  <div>
    <b-form-group label="Dátumformátum">
      <template
        v-if="selection === 'auto'"
      >
        <b-form-radio-group
          :id="name"
          v-model="selection"
          :name="name"
        >
          <b-form-radio
            value="auto"
            :class="radioClass"
          >
            <div>{{ auto.text }}</div>
            <small class="text-danger" v-if="!hasSuggestion">Nem támogatott dátumformátum, vagy a kiküldés időpontja nincs hozzárendelve.</small>
          </b-form-radio>
          <b-form-radio
            :value="suggested.value"
            :class="radioClass"
          >
            <div>Kézi</div>
          </b-form-radio>
        </b-form-radio-group>
      </template>
      <template
        v-if="selection !== 'auto'"
      >
        <b-form-radio-group
          :id="name"
          v-model="selection"
          :name="name"
        >
          <template
            v-for="(element, index) in values"
          >
            <b-form-radio
              v-if="element.value === 'auto'"
              :value="element.value"
              :key="index"
              :class="radioClass"
            >
              <div>{{ element.text }}</div>
            </b-form-radio>
            <b-form-radio
              v-if="element.value !== 'auto'"
              :value="element.value"
              :key="index"
              :class="radioClass"
            >
              <div :class="{'font-weight-bold': suggestedFormat === element.value }">
                {{ element.text }}
                <small class="badge badge-info ml-1" v-if="suggestedFormat === element.value">Javasolt formátum</small>
              </div>
              <code>{{ element.value }}</code>
            </b-form-radio>
          </template>
        </b-form-radio-group>
      </template>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      },
      name: {
        type: String,
        default: 'date_format'
      },
      label: {
        type: String,
        default: ''
      },
      values: {
        type: Array,
        default: () => ([])
      },
      suggestions: {
        type: Object,
        default: () => ({
          date_format: ''
        })
      },
      radioClass: {
        type: String,
        default: 'd-block mb-2'
      }
    },
    data() {
      return {
        selection: '',
        hasSuggestion: true,
        suggestedFormat: '',
      }
    },
    computed: {
      suggested() {
        var suggested = this.findElement((element) => element.value === this.suggestedFormat, false)
        if(suggested === false) {
          return this.findElement((element) => element.value !== 'auto')
        }

        return suggested
      },
      auto() {
        return this.findElement((element) => element.value === 'auto')
      }
    },
    watch: {
      selection(selection) {
        this.$emit('input', selection)
      },
      value(value) {
        this.selection = value
      },
      'suggestions.date_format': function(format) {
        if(format === false) {
          this.hasSuggestion = false
          this.suggestedFormat = ''
          return
        }

        this.hasSuggestion = true
        this.suggestedFormat = format
      }
    },
    methods: {
      findElement(predicate, defaultValue = {text: '', value: ''}) {
        if (this.values.length === 0) {
          return ''
        }

        var element = _.find(this.values, predicate)
        if (typeof element !== 'undefined') {
          return element
        } else {
          return defaultValue
        }
      }
    }
  }
</script>